import { HttpClient, HttpContext, HttpHeaders } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";

import { BehaviorSubject, Observable, Subject } from "rxjs";

import { AuthService } from "src/app/services/auth.service";

import { takeUntil, tap } from "rxjs/operators";

import {
  AddSkusToBoxRequest,
  AddSkuToBoxRequest,
  ConfirmShipmentPayload,
  ConfirmShipmentPlan,
  ConfirmShipmentSpPayload,
  CreateDraftShipmentPayload,
  EditShipmentSkuRequest,
  Publish,
  ShipmentSku,
  ShipmentSkuResolvedPayload,
  UpdateIsStarredPayload,
} from "src/app/models/shipyard.model";
import { AgGridRequestService } from "src/app/services/ag-grid-request.service";
import {
  AssignTo3PLPayload,
  GetBoxLabelRequestModel,
  GetShipmentListPayload,
} from "src/app/models/shipment.model";
import { HIDE_ERROR_NOTIFICATIONS } from "src/app/core/token-interceptor.service";
import { StorageKeyEnum } from "src/app/core/StorageKeyEnum";

import { HeaderService } from "./../../components/header/header.service";
import { InventoryService } from "src/app/services/inventory.service";

@Injectable({
  providedIn: "root",
})
export class ShipyardService implements OnDestroy {
  scanningBoxId: string;
  destroy$ = new Subject<void>();
  private url = "api/Shipments";
  account;
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  skusToAddToShipment:any[] = [];
  purchasingQueue:any;
  subSkusToAddToShipment = [];
  splittedShipmentType = [];
  shipmentTypeToAddToShipment: Subject<string> = new Subject();
  shipmentTypeToAddToShipment$: Subject<string> = new Subject();
  shipmentSearch$: Subject<any> = new Subject();
  cellFocusedIndex: number;
  filterName = "all";
  isPlanAll: BehaviorSubject<any> = new BehaviorSubject(null);
  isWarehouse: BehaviorSubject<any> = new BehaviorSubject(null);
  navigateAwaySelection$: Subject<boolean> = new Subject<boolean>();
  planProgress: BehaviorSubject<any> = new BehaviorSubject(null);
  planCount: number = 1;
  shipmentTypeToAddToShipments: string;
  shipmentHeaderIds: BehaviorSubject<any> = new BehaviorSubject(null);
  splittedShipmentType$: Subject<any> = new Subject();
  scanTempBox: any;
  planProcess:any = [];
  planProcessWithDestination:any = [];
  planAllById:any = [];
  createShipment:any = [];
  scanShipmentSkusBox: Array<ShipmentSku> = new Array<ShipmentSku>();
  shipmentSkus: Array<ShipmentSku> = new Array<ShipmentSku>();
  scanShipmentSkuQty: Subject<number> = new Subject<number>();
  scanShipmentHeaderId: Subject<number> = new Subject<number>();
  totalQty: number = 0;
  totalSku: number = 0;
  scanShipmentBoxId: Subject<number | string> = new Subject<
    number | string
  >();
  scanShipmentLoading: Subject<any> = new Subject<any>();
  isScanining: boolean = false;
  boxIdFor:number=0;  
  ShipIdChange: any;
  seasonalValueChanged: BehaviorSubject<any> = new BehaviorSubject(null);
  loadCreateShipment: boolean = false;
  warehouseId: number;
  printSkuEventIds:any[]=[];
  updateQueueCount: Subject<boolean> = new Subject<boolean>();
  exportShipmentEvent:any[]=[];
  missingCogs:boolean=false;
  skuFilterSet:any;
  isTagAdded:boolean=false;
  isFirstRender = true;
  selectedCellValue$: Subject<string> = new Subject<string>();
  purchasingQueueCount:number=0;

  constructor(
    private http: HttpClient,
    private agGridRequestService: AgGridRequestService,
    private headerService: HeaderService,
    private authService: AuthService,
    private inventoryService: InventoryService
  ) {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e[0]));
    this.shipmentTypeToAddToShipment$.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.shipmentTypeToAddToShipments = e;
    });
  }

  GetShipments(
    account,
    startRow,
    endRow,
    statuses?: string[],
    ShipmentType?,
    data?: GetShipmentListPayload,
  ) {
    return this.http.get(
      `/${
        this.url
      }/GetShipments?Account=${account}&StartRow=${startRow}&EndRow=${endRow}${
        statuses.length
          ? statuses.map((status) => `&Statuses=${status}`).join("")
          : ""
      }${ShipmentType != null ? "&ShipmentType=" + ShipmentType : ""}${
        data && data.shipmentType != null
          ? "&ShipmentType=" + data.shipmentType
          : ""
      }${data && data.shipmentId ? "&ShipmentId=" + data.shipmentId : ""}${
        data && data.containSkus ? "&HasSku=" + data.containSkus : ""
      }${data && data.containsAsin ? "&HasAsin=" + data.containsAsin : ""}${
        data && data.boxContents
          ? "&WithBoxContentOnly=" + data.boxContents
          : ""
      }${
        data && data.isCompleted !=null
          ? "&isCompleted=" + data.isCompleted
          : ""
      }${
        data && data.dateCreated ? "&dateCreated=" + data.dateCreated : ""
      }${
        data && data.isGroupShipmentsByPlan
          ? "&IsGroupShipmentsByPlan=" + data.isGroupShipmentsByPlan
          : ""
      }${
        data && data.hideDeleted ? "&HideDeleted=" + data.hideDeleted : ""
      }`,
      this.options
    );
  }

  GetShipmentDetail(shipmentId: number, refresh: boolean) {
    return this.http.get(
      `/${this.url}/GetShipmentDetails?ShipmentHeaderID=${shipmentId}&IsRefresh=${refresh}`,
      {
        ...this.options,
        context: new HttpContext().set(HIDE_ERROR_NOTIFICATIONS, true),
      }
    );
  }

  EditShipmentSku(shipmentSku: EditShipmentSkuRequest) {
    return this.http.post(`/${this.url}/EditShipmentSkuSP/`, shipmentSku, {
      ...this.options,
      context: new HttpContext().set(HIDE_ERROR_NOTIFICATIONS, true),
    });
  }

  EditShipmentSkuSP(shipmentSku: EditShipmentSkuRequest) {
    return this.http.post(`/${this.url}/EditShipmentSkuSP/`, shipmentSku, {
      ...this.options,
      context: new HttpContext().set(HIDE_ERROR_NOTIFICATIONS, true),
    });
  }

  AddSkuToBox(addSkuToBoxRequest: AddSkuToBoxRequest) {
    return this.http.post(
      `/${this.url}/AddSkuToBox/`,
      addSkuToBoxRequest,
      this.options
    );
  }

  AddSkuListToBox(addSkusToBoxRequest: AddSkusToBoxRequest) {
    return this.http.post(
      `/${this.url}/AddSkuToBoxList`,
      addSkusToBoxRequest,
      this.options
    );
  }

  AddSkuListToBoxValidationCheck(addSkuToBoxRequest: any) {
    return this.http.post(
      `/${this.url}/AddSkuToBoxListValidation/`,
      addSkuToBoxRequest,
      this.options
    );
  }

  CreateBox(shipmentHeaderId: number) {
    return this.http.post(
      `/${this.url}/CreateBox/`,
      { shipmentHeaderId },
      this.options
    );
  }

  ExportShipment(shipmentHeaderId: number): Observable<any> {
    return this.http.post(
      `/${this.url}/ExportShipment/`,
      { shipmentHeaderId },
      {
        headers: this.headers,
        observe: "response",
        responseType: "blob",
      }
    );
  }

  UnpackBox(boxId: number, shipmentHeaderId: number) {
    return this.http.post(
      `/${this.url}/UnpackBox/`,
      { shipmentHeaderId, boxId },
      this.options
    );
  }

  UnpackAll(shipmentHeaderId: number) {
    return this.http.post(
      `/${this.url}/UnpackAll/`,
      { shipmentHeaderId },
      this.options
    );
  }

  RemoveEmptyBoxes(shipmentHeaderId: number) {
    return this.http.post(
      `/${this.url}/RemoveEmptyBoxes/`,
      { shipmentHeaderId },
      this.options
    );
  }

  DeleteBox(boxId: number, shipmentHeaderId: number) {
    return this.http.post(
      `/${this.url}/DeleteBox/`,
      { shipmentHeaderId, boxId },
      this.options
    );
  }

  CreateShipmentDraft(createDraftShipmentPayload: CreateDraftShipmentPayload) {
    return this.http.post(
      `/${this.url}/CreateShipmentDraft/`,
      createDraftShipmentPayload,
      this.options
    );
  }

  TypeaheadSku(account, query, type = "", ShowAllFullfilments?,ActiveOnly?) {
    const encodedQuery = encodeURIComponent(query);
    return this.http.get(
      `/${this.url}/TypeaheadSku?Account=${account}&Qry=${encodedQuery}&Type=${type}${
        ShowAllFullfilments ? "&ShowAllFullfilments=" + ShowAllFullfilments : ""
      }${
        ActiveOnly ? "&ActiveOnly=" + ActiveOnly : ""
      }`,
      this.options
    );
  }

  ClearShipment(shipmentHeaderId, DeleteBoxed) {
    return this.http.post(
      `/${this.url}/ClearShipment/`,
      { shipmentHeaderId, DeleteBoxed },
      {
        ...this.options,
        context: new HttpContext().set(HIDE_ERROR_NOTIFICATIONS, true),
      }
    );
  }

  PrintSku(data) {
    return this.http.post(`/${this.url}/NewPrintSkuWithIdByUser/`, data, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }

  PrintSkuSp(data) {
    return this.http.post(`/${this.url}/NewPrintSkuWithIdSPByUser/`, data, {
      ...this.options,
      context: new HttpContext().set(HIDE_ERROR_NOTIFICATIONS, true),
    });
  }

  GetShipmentPlans(shipmentType) {
    return this.http.get(
      `/${this.url}/GetShipmentPlans?Account=${this.account}&ShipmentType=${shipmentType}`,
      this.options
    );
  }

  GetShipmentAddress() {
    return this.http.get(
      `/${this.url}/GetShipmentAddress`,
      this.options
    );
  }

  PlanShip(data) {
    data["account"] = this.account;
    return this.http.post(`/${this.url}/PlanShip`, data, this.options);
  }

  PlanShipSp(data) {
    data["account"] = this.account;
    return this.http.post(`/${this.url}/PlanShipSpNewError`, data, this.options);
  }

  ConfirmShipment(payload: ConfirmShipmentPayload) {
    return this.http
      .post(`/${this.url}/ConfirmShipment`, payload, this.options)
      .pipe(
        tap(() => {
          this.HasFreemiumCredits().pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.updateLocalStorageKey("freemiumAvail", res);
          });
        })
      );
  }

  ConfirmShipmentSp(payload: ConfirmShipmentSpPayload) {
    return this.http
      .post(`/${this.url}/ConfirmShipmentPlans`, payload, this.options)
      .pipe(
        tap(() => {
          this.HasFreemiumCredits().pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.updateLocalStorageKey("freemiumAvail", res);
          });
        })
      );
  }

  MergeShipment(shipmentHeaderId, destinationShipmentId) {
    return this.http.post(
      `/${this.url}/MergeShipment`,
      { shipmentHeaderId, destinationShipmentId },
      this.options
    );
  }

  ConfirmAndMerge(SourceShipmentHeaderId, ShipmentPlanHeaderId) {
    return this.http.post(
      `/${this.url}/ConfirmAndMerge`,
      { SourceShipmentHeaderId, ShipmentPlanHeaderId },
      this.options
    );
  }

  CompleteShipment(
    shipmentHeaderId: number,
    submitBoxContent: boolean,
    overFlowToDraft: boolean,
    isFeed:boolean
  ) {
    return this.http.post(
      `/${this.url}/CompleteShipment`,
      { shipmentHeaderId, submitBoxContent, overFlowToDraft,isFeed },
      this.options
    );
  }

  DeleteShipmentDraft(shipmentHeaderId: number) {
    return this.http.post(
      `/${this.url}/DeleteShipmentDraft`,
      { shipmentHeaderId },
      this.options
    );
  }

  RemoveSkuFromBox(payload) {
    return this.http.post(
      `/${this.url}/RemoveSkuFromBoxes`,
      payload,
      this.options
    );
  }

  UpdateBoxSkuQty(
    sku: string,
    shipmentHeaderId: number,
    qty: number,
    boxId: number,
    append: boolean
  ) {
    return this.http.post(
      `/${this.url}/UpdateBoxSkuQty`,
      { sku, shipmentHeaderId, qty, boxId, append },
      this.options
    );
  }

  GetSkuList(body, columnDefs, globalSearch?,sumColumnDefs?,vendor?,isModel = false) {
    let filters = {};
    if (this.account && !isModel) {
      filters["Account"] = {
        filterType: "set",
        values: [this.account],
      };
    }
    if(vendor){
      filters["Vendors"] = {
        filterType: "text",
        type: "contains",
        filter: vendor,
      };
    }
    if(this.skuFilterSet){
      filters["Sku"] = {
        filterType: "set",
        values: this.skuFilterSet
      };
    }

    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      filters,
      sumColumnDefs
    );
    if(this.warehouseId) payload.warehouseId = this.warehouseId;
    payload.missingCost=this.missingCogs;
    return this.http.post(`api/Repricer/GetSkuList1`, payload, {
      ...this.options,
      context: new HttpContext().set(HIDE_ERROR_NOTIFICATIONS, true),
    });
  }

  DownloadShipments(account: string) {
    return this.http.get(
      `/${this.url}/DownloadShipments?Account=${account}`,
      this.options
    );
  }
  DownloadShipmentsSp(account: string) {
    return this.http.get(
      `/${this.url}/DownloadShipmentSp?Account=${account}`,
      this.options
    );
  }

  PrintBoxLabels(isBox?,boxes?: any, shipmentHeaderId?: number) {
    return this.http.post(
      `/${this.url}/PrintBoxLabelsVByUser`,
      isBox ? boxes: { boxes, shipmentHeaderId },
      {
        headers: this.headers,
        observe: "response",
        responseType: "blob",
      }
    );
  }

  Print2dLabel(getBoxLabelRequestModel: GetBoxLabelRequestModel) {
    return this.http.post(
      `/${this.url}/Print2dLabelVByUser`,
      getBoxLabelRequestModel,
      {
        headers: this.headers,
        observe: "response",
        responseType: "blob",
      }
    );
  }

  ValidateBulkSkus(bulkSkuReq) {
    return this.http.post(
      `/${this.url}/ValidatBulkSkus/`,
      bulkSkuReq,
      this.options
    );
  }

  ResyncDetail(shipmentDetailId: number) {
    return this.http.post(
      `/${this.url}/ResyncDetail`,
      { shipmentDetailId },
      this.options
    );
  }

  ResyncShipment(shipmentHeaderId: number) {
    return this.http.post(
      `/${this.url}/ResyncShipment`,
      { shipmentHeaderId },
      this.options
    );
  }

  AddByBoxQty(shipmentHeaderId: number) {
    return this.http.post(
      `/${this.url}/AddByBoxQty`,
      { shipmentHeaderId },
      this.options
    );
  }

  PlanAll(data) {
    return this.http.post(`/${this.url}/PlanAll`, data, this.options);
  }

  HasFreemiumCredits() {
    return this.http.post(`/${this.url}/HasFreemiumCredits`, {}, this.options);
  }

  AssignFreemium(shipmentHeaderId: number) {
    return this.http.post(
      `/${this.url}/AssignFreemium`,
      { shipmentHeaderId },
      this.options
    );
  }

  moreThenOne(drag) {
    if (drag.data.length) {
      return true;
    } else if (drag.data && drag.data.qty > 1) {
      return true;
    }
    return false;
  }

  updateLocalStorageKey(key, value) {
    const user = JSON.parse(localStorage.getItem(StorageKeyEnum.User));
    user[key] = value;
    localStorage.setItem(StorageKeyEnum.User, JSON.stringify(user));
    this.authService.userInfo$.next(user);
  }

  SaveShipmentCompleted(shipmentHeaderID, completed) {
    return this.http.post(
      `/${this.url}/SaveShipmentCompleted`,
      { shipmentHeaderID, completed },
      this.options
    );
  }

  SaveShipmentData(payload) {
    return this.http.post(
      `/${this.url}/SaveShipmentData`,
       {payload} ,
      this.options
    );
  }

  CancelTo3PL(shipmentHeaderID) {
    return this.http.post(
      `/${this.url}/CancelTo3PL`,
      { shipmentHeaderID },
      this.options
    );
  }

  UpdateWarehouse(payload){
    return this.http.post(
      `/${this.url}/UpdateWarehouse`,payload,
      this.options
    );
  }

  getShipmentTypeId(shipmentType) {
    switch (shipmentType) {
      case "Standard":
        return 0;
      case "Oversized":
        return 1;
      case "Hazmat":
        return 2;
      case "Small & Light":
        return 3;
      case "Aerosol":
        return 4;
      case "Large Oversized":
        return 5;
      default:
        return "";
    }
  }

  getShipmentTypeName(shipmentTypeId) {
    switch (shipmentTypeId) {
      case 0:
        return "Standard";
      case 1:
        return "Oversized";
      case 2:
        return "Hazmat";
      case 3:
        return "Small & Light";
      case 4:
        return "Aerosol";
      case 5:
        return "Large Oversized";
      default:
        return "";
    }
  }

  getAllShipmentTypeNames() {
    return this.getAllShipmentTypes().map((shipmentType) => shipmentType.name);
  }

  getAllShipmentTypes() {
    return [
      { id: 0, name: "Standard" },
      { id: 1, name: "Oversized" },
      { id: 2, name: "Hazmat" },
      { id: 3, name: "Small & Light" },
      { id: 4, name: "Aerosol" },
      { id: 5, name: "Large Oversized" },
    ];
  }

  AssignTo3PL(payload: AssignTo3PLPayload) {
    return this.http.post(`/${this.url}/AssignTo3PL/`, payload, this.options);
  }

  MoveShipmentToDraft(payload) {
    return this.http.post(`/${this.url}/MoveShipmentToDraft/`, payload, this.options);
  }
  ExportBoxes(shipmentHeaderID: number): Observable<any>{
    return this.http.post(
      `/${this.url}/ExportBoxes`,
      { shipmentHeaderID },
      {
        headers: this.headers,
        observe: "response",
        responseType: "blob",
      }
    );
  }  
  editShipmentBoxDimension(payload){
    return this.http.post(`/${this.url}/EditShipmentBoxDimension/`, payload, this.options);
  
  }

  addMultiSkuToBox(payload) {
    return this.http.post(`/${this.url}/AddMultiSkuToBox`, payload, this.options);
  }
 
  ExportBoxesFromAmazon(shipmentHeaderID: number): Observable<any>{
    return this.http.post(
      `/${this.url}/ExportBoxesFromAmazon`,
      { shipmentHeaderId: shipmentHeaderID },
      {
        headers: this.headers,
        observe: "response",
        responseType: "blob",
      }
    );
  }

  AddByBoxCaseQty(payload) {
    return this.http.post(
      `/${this.url}/AddCaseQtySelectSkus`,
      payload,
      this.options
    );
  }

  SetSkuResolved(payload:ShipmentSkuResolvedPayload) {
    return this.http.post(
      `/${this.url}/SetShipmentSkuResolved/`,
      payload,
      this.options
    );
  }
  
  UpdateBoxContentShipment(payload) {
    return this.http.post(`/${this.url}/UpdateBoxContentShipment`, payload, this.options);
  }

  GetShipmentDetailList(shipmentHeaderId) {
    return this.http.get(
      `/${this.url}/GetShipmentDetailList?ShipmentHeaderID=${shipmentHeaderId}`,this.options
    );
  }
  
  CreateMultipleBox(payload) {
    return this.http.post(`/${this.url}/CreateBoxes/`,payload,this.options);
  }


  ClearAll(payload){
    return this.http.post(
      `/${this.url}/ClearShipmentBoxDimension/`,payload,this.options
    );
  }


  UpdateShipmentName(payload){
    return this.http.post(
      `/${this.url}/UpdateShipmentName`,payload,
      this.options
    );
  }

  UpdateWarehouseShipment(payload){
    return this.http.post(
      `/${this.url}/UpdateWarehouseShipment`,payload,
      this.options
    );
  }

  UpdateDeductWarehouseShipment(payload){
    return this.http.post(
      `/${this.url}/UpdateDeductWarehouseShipment`,payload,
      this.options
    );
  }

  PlanAddAllHere(payload){
    return this.http.post(
      `/${this.url}/PlanAddAllHere`,payload,
      this.options
    );
  }


  ExportBoxesDetail(shipmentHeaderID: number): Observable<any>{
    return this.http.post(
      `/${this.url}/ExportBoxesDetail`,
      { shipmentHeaderId: shipmentHeaderID },
      {
        headers: this.headers,
        observe: "response",
        responseType: "blob",
      }
    );
  }

  ConfirmShipmentPlan(payload: ConfirmShipmentPlan) {
    return this.http
      .post(`/${this.url}/ConfirmShipmentPlans`, payload, this.options)
      .pipe(
        tap(() => {
          this.HasFreemiumCredits().pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.updateLocalStorageKey("freemiumAvail", res);
          });
        }
      )
    );
  }


  PlanAmazonShipment(data) {
    data["account"] = this.account;
    return this.http.post(`/${this.url}/PlanAmazonShipment`, data, this.options);
  }

  exportShipmentPlan(shipmentId){
    return this.http.post(`/${this.url}/ExportShipmentPlan`, {shipmentId},{
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }

  DeleteShipmentAmazon(payload) {
    return this.http.post(
      `/${this.url}/DeleteShipmentAmazon`,
       payload,
      this.options
    );
  }


  b64toBlob(dataURI) {
    dataURI='data:application/octet-stream;base64,'+dataURI;
    var byteString = atob(dataURI.split(',')[1]);
    var data = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(data);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([data], { type: 'application/pdf' });
}

  CheckValidationForNegativeQty(payload) {
    return this.http.post(
      `/${this.url}/CheckValidationForNegativeQty`, payload, this.options
    );
  }


  TypeaheadFcs(query,whsId,shipmentType?) {
    return this.http.get(
      `/${this.url}/TypeaheadFcs?Qry=${query}${whsId ? "&WarehouseId="+whsId : ""}${shipmentType != null ? "&ShipmentType=" + shipmentType : ""}`,
      this.options
    );
  }

  //Handling Blob Error
  blobToString(blob): string {
    const url = URL.createObjectURL(blob);
    let xmlRequest = new XMLHttpRequest();
    xmlRequest.open('GET', url, false);
    xmlRequest.send();
    URL.revokeObjectURL(url);
    return JSON.parse(xmlRequest.responseText);
 }


  downloadCatalogAsin(payload) {
    return this.http.post(
      `/${this.url}/DownloadCatalogAsin`, payload, this.options);
  }

  CreateFBAInventory(payload: Publish) {
    return this.http.post(`/${this.url}/CreateFBAInventory`, payload, this.options)
  }

  CreateShipmentQueue(payload) {
    return this.http.post(
      `/${this.url}/CreateShipmentQueue`,
      payload,
      this.options
    );
  }

GetShipmentQueue(account){
  return this.http.get(
    `/${this.url}/GetShipmentQueue?Account=${account}`,
    this.options
  );
}

RemoveShipmentQueue(payload){
  return this.http.post(
    `/${this.url}/RemoveShipmentQueue`,
    payload,
    this.options
    );
  }

  GetShipmentQueueCount(account){
    return this.http.get(
      `/${this.url}/GetShipmentQueueCount?Account=${account}`,
      this.options
    );
  }

  ShipmentUpdateUserNote(payload) {
    return this.http.post(`/${this.url}/ShipmentUpdateUserNote`, payload, this.options);
  }

  GetShipmentByPlanId(planId,shipmentId,primaryShipmentId){
    return this.http.get(
      `/${this.url}/GetShipmentByPlanId?Account=${this.account}&PlanId=${planId}${shipmentId != null ? "&ShipmentId=" + shipmentId : ""}${primaryShipmentId != null ? "&PrimaryShipmentId=" + primaryShipmentId : ""}`,
      this.options
    );
  }

  UpdateIsStarredShipments(updateIsStarredPayload: UpdateIsStarredPayload){
    return this.http.post(`/${this.url}/UpdateIsStarredShipments`, updateIsStarredPayload, this.options);
  }  

  GetRelatedShipment(shipmentId,account){
    return this.http.get(
      `/${this.url}/GetRelatedShipment?ShipmentId=${shipmentId}&Account=${account}`,
      this.options
      );
  }

  GetShipmentBreakdown(
    account,
    startRow,
    endRow,
    HasSku? 
  ) {
    return this.http.get(
      `/${
        this.url
      }/GetShipments?Account=${account}&StartRow=${startRow}&EndRow=${endRow}&HasSku=${HasSku}`,
      this.options
    );
  }

  exportShipment(payload) {
    return this.http.get(`/${this.url}/ExportShipmentList?Account=${payload.account}&Type=${payload.type}`, 
    this.options
   )
  }

  ExportShipmentListHeaderDetail(payload) {
    return this.http.get(`/${this.url}/ExportShipmentListHeaderDetail?Account=${payload.account}&Type=${payload.type}&IsHeader=${payload.isHeader}${
      payload.Statuses?.length
        ? payload.Statuses.map((status) => `&Statuses=${status}`).join("")
        : ""
    }`, 
    this.options
   )
  }

  ShippedShipmentAmazon(payload){
    return this.http.post(`/${this.url}/ShippedShipmentAmazon`, payload, this.options);
  }

  GetClaimList(body, columnDefs, globalSearch?,sumColumnDefs?) {
    let filters = {};

    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      filters,
      sumColumnDefs
    );
    return this.http.post(`${this.url}/GetClaimList`, payload,this.options,
    );
  }
  checkSkuExist(payload){
    return this.http.get(`/${this.url}/CheckSkuExist?Sku=${payload}`,this.options)
  }

  typeaheadSkuProduct(account, query, type = "", ShowAllFullfilments?,ActiveOnly?) {
    const encodedQuery = encodeURIComponent(query);
    return this.http.get(
      `/${this.url}/TypeaheadSkuProduct?Account=${account}&Qry=${encodedQuery}&Type=${type}${
        ShowAllFullfilments ? "&ShowAllFullfilments=" + ShowAllFullfilments : ""
      }${
        ActiveOnly ? "&ActiveOnly=" + ActiveOnly : ""
      }`,
      this.options
    );
  }

  createPlanBySku(payload){
    return this.http.post(`/${this.url}/createPlanBySku`, payload, this.options);
  }

  assignFreemiumPlanHeaderId(shipmentHeaderId: number) {
    return this.http.post(
      `/${this.url}/AssignFreemiumPlanHeaderId`,
      { shipmentPlanHeaderId: shipmentHeaderId },
      this.options
    );
  }
  setFilterModel(params,isTags?){
    let tagId: any[] = [];
   if(!this.isTagAdded || params.request.filterModel?.Tags?.intValues?.length){
    if(params.request.filterModel?.Tags && (params.request.filterModel?.Tags?.values?.length || params.request.filterModel?.Tags?.intValues?.length)){
      let tags = params.request.filterModel?.Tags?.intValues || params.request.filterModel?.Tags?.values;
      tags.forEach((res)=>{
        let index = this.inventoryService.getTags.findIndex((result) => result?.name === res ||  result?.tagId === res);
        if(index !== -1) tagId.push(this.inventoryService.getTags[index].tagId);
      });
      this.setTagFilter(params,tagId);     
    } else if(!params.request.filterModel?.Tags && !this.isFirstRender && isTags) {
      this.inventoryService.getTags?.forEach((res)=>{
        tagId.push(res.tagId);
      });
      this.setTagFilter(params,tagId);
    } else if(!params.request.filterModel?.Tags?.values.length) {
      delete params?.request?.filterModel?.Tags;
    } 
  } else {
    delete params?.request?.filterModel?.Tags;
  }
  this.isTagAdded = false;
    this.isFirstRender = false;
  }

  setTagFilter(params,tags){
    const filter = {
      Tags: {
        filterType: "number",
        type: "in",
        intValues: tags.length ? tags : [0],
      },
    }
    delete params?.request?.filterModel.Tags;
    params.request.filterModel.Tags = filter.Tags;  

  }

  forecastingSaveDraftShipment(payload){
    return this.http.post(`/${this.url}/ForecastingSaveDraftShipment`, payload, this.options);
  }
  
  saveShipmentAttachment(payload){
    return this.http.post(`/${this.url}/SaveShipmentAttachment`,payload, this.options);
  }

  deleteShipmentAttachment(payload){
    return this.http.post(`/${this.url}/DeleteShipmentAttachment`,payload, this.options);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  
  getRelatedShipmentTableView(shipmentId,account){
    return this.http.get(`/${this.url}/GetRelatedShipmentTableView?ShipmentId=${shipmentId}&Account=${account}`,this.options)
  }


  updateShipingPrice(payload){
    return this.http.post(
      `/${this.url}/UpdateShipingPrice`,payload,
      this.options
    );
  }
  shipmentHeaderList(body, columnDefs, globalSearch?,account?,sumColumnDefs?) {
    let filters;
    if(account){
      filters = {
        Account: {
          filterType: "set",
          values: account,
        },
      } 
    }
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      filters
    );
    return this.http.post(`/${this.url}/ShipmentHeaderList`, payload, this.options);
  }

  getFCForWarehouse (warehouseId,shipmentType?){
    return this.http.get(`/${this.url}/GetFCForWarehouse?WarehouseId=${warehouseId}${shipmentType != null || shipmentType == 0 || shipmentType > 0? `&ShipmentType=${shipmentType}`: ""}`,this.options)
  }

  addFavoriteFC(payload){
    return this.http.post(`/${this.url}/AddFavoriteFC`,payload,this.options);
  }

  deleteFavoriteFC(payload){
    const url = `${this.url}/DeleteFavoriteFC`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.delete(url, { headers, body: payload });
  }

 getLocationRecommendations(fulfillmentCenterId,shipmentType=null){
    return this.http.get(`/${this.url}/GetLocationRecommendations?FulfillmentCenterId=${fulfillmentCenterId}${shipmentType == 0 || shipmentType > 0? `&ShipmentType=${shipmentType}`: ""}`,this.options)
  }

  GetMerchantShippingGroup(account:string){
    return this.http.get(`/${this.url}/GetMerchantShippingGroup?Account=${account}`,this.options)
  }
  
  shipmentHeaderListExport(filters, columns, globalSearch,isExport?){
    const body = {
      filterModel: filters,     
    };

    if (this.account) {
      filters["Account"] = {
        filterType: "set",
        values: [this.account],
      };
    }
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columns,
      globalSearch,
      null,
      null,
      isExport
    );

    return this.http.post(`/${this.url}/ShipmentHeaderListExport`, payload, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });

  }

  addDeductFromInventory(payload){
    return this.http.post(`/${this.url}/ShipmentDeduction`,payload,this.options);
  } 
  
  getInboundPlacementFeesForSkus(payload){
    return this.http.post(`/${this.url}/GetInboundPlacementFeesForSkus`,payload,this.options);
  }

  getTotalInboundPlacementFeesForSkus(payload){
    return this.http.post(`/${this.url}/GetTotalInboundPlacementFeesForSkus`,payload,this.options);
  }

  ShipmentDeductionAlertCount(){
    return this.http.get(
      `/${this.url}/ShipmentDeductionAlertCount`,
      this.options
    );
  }

  ShipmentDeductionAlertDetail(){
      return this.http.get(
        `/${this.url}/ShipmentDeductionAlertDetail`,
        this.options
      );
  }

  ShipmentDeductionAlertDetailExport(account){
    return this.http.post(`/${this.url}/ShipmentDeductionAlertDetailExport?Account=${account}`, {}, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }
}
